import React, { useState, useEffect } from 'react';
import { 
  FiCalendar, 
  FiClock, 
  FiMapPin, 
  FiChevronDown, 
  FiChevronUp, 
  FiFilter, 
  FiSearch,
  FiUser,
  FiShare2,
  FiBookmark,
  FiHeart
} from 'react-icons/fi';
import './Events.css';

const EventsPage = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    category: 'all',
    date: 'upcoming',
    search: ''
  });
  const [expandedEvent, setExpandedEvent] = useState(null);
  const [savedEvents, setSavedEvents] = useState([]);

  useEffect(() => {
    setLoading(true);
    const mockEvents = [
      
      {
        id: 1,
        title: "ASPIRA Leadership Conference",
        category: "career",
        date: "2025-9-18",
        time: "1:00 PM - 3:00 PM",
        location: "Remote Meeting",
        description: "ASPIRA's annual leadership conference featuring workshops on professional development and networking opportunities.",
        image: "https://source.unsplash.com/random/600x400/?leadership,conference",
        attendees: 85,
        organizer: "ASPIRA",
        registerLink: "https://aspiraa.netlify.app/"
      },
      {
        id: 2,
        title: "ProjectUcodeNC Tutoring Event and Hackathon",
        category: "academic",
        date: "2025-10-02",
        time: "10:00 AM - 8:00 PM",
        location: "Engineering Building",
        description: "24-hour coding competition where students build innovative projects. Prizes for top teams!",
        image: "https://source.unsplash.com/random/600x400/?hackathon,coding",
        attendees: 120,
        organizer: "ProjectUcode",
        registerLink: "https://docs.google.com/forms/d/1kLH6jdokMgr-PQa6sD54bfwup7yNsB5tNo88vMIc4lA/edit#responses"
      },
      {
        id: 3,
        title: "Register for W.I.S.H Officer Leadership Positions",
        category: "academic",
        date: "2025-9-02",
        time: "12:00 PM - 12:00 AM",
        location: "Remote Form",
        description: "A chance to lead and make an impact in the W.I.S.H community. Apply for officer positions to help shape our initiatives and events.",
        image: "https://source.unsplash.com/random/600x400/?hackathon,coding",
        attendees: 100,
        organizer: "W.I.S.H",
        registerLink: "https://docs.google.com/forms/d/e/1FAIpQLSdh0U2ZVjufMVM32w39cJuCsou-25anPGBCRz6cTFW65WJtRw/closedform"
      },
         {
        id: 4,
        title:  "Book a Cut With Ivan Cheah",
        category: "social",
        date: "Avaible Now",
        time: "12:00 PM - 12:00 AM",
        location: "Ivans Barbershop",
        description: "Book a haircut with Ivan Cheah, a professional barber with over 3 years of experience. Get the perfect cut for any occasion.",
        image: "https://source.unsplash.com/random/600x400/?hackathon,coding",
        attendees: 300,
        organizer: "Ivan Cheah",
        registerLink: "https://calendly.com/ivan-cheah07?fbclid=PAZXh0bgNhZW0CMTEAAafJSxfZp9GrVOAVJglAYmVRAIbwY5S1aYHbZOa9d_U6MQDs7vNXAGeov7l7jQ_aem_QvlhikvGttbQrjNNFY0Vng"
      },   {
        id: 5,
        title: "T1D United Officer Positions",
        category: "social",
        date: "2025-10=10",
        time: "12:00 PM - 12:00 AM",
        location: "Remote Form",
        description: "1D United was founded by Krisha Karamchandani and Krivisha Nuthakki with the mission to raise awareness and funds for Type 1 Diabetes. Fill out their form to apply for officer positions and help spread awareness.",
        image: "https://source.unsplash.com/random/600x400/?hackathon,coding",
        attendees: 100,
        organizer: "T1D United",
        registerLink: "https://docs.google.com/forms/d/e/1FAIpQLScBG4bsn_CruPCYwuXdD-yfHJ2Qp9YUaSX5bL_fyecHA9Ys-w/viewform?usp=header"
      },   
       {
        id: 6,
        title: "MindsetMath Forms",
        category: "academic",
        date: "2026",
        time: "12:00 PM - 12:00 AM",
        location: "Remote Forms",
        description: "Go become a member for MindsetMath and go join their internship programs and more wonderful oppurtunites to boost your college APPS!!!",
        image: "https://source.unsplash.com/random/600x400/?hackathon,coding",
        attendees: "N/A",
        organizer: "MindsetMath",
        registerLink: "https://www.instagram.com/mindset.math"
      },
    
      {
        id: 7,
        title: "CYMA Business Showcase ",
        category: "social",
        date: "2025",
        time: "11:00 AM - 5:00 PM",
        location: "Ballantyne Backyard",
        description: "Community showcase, hosting a wide varity of business for showcase, allowing more customers and members!",
        image: "https://source.unsplash.com/random/600x400/?hackathon,coding",
        attendees: 300,
        organizer: "CYMA",
        registerLink: "https://www.eventbrite.com/e/the-charlotte-fort-mill-business-showcase-tickets-1383220663239"
      },
      {
        id: 8,
        title: "QCB Cuts",
        category: "social",
        date: "2026",
        time: "NA",
        location: "Barbershop Adis",
        description: "Go get your cut from Adi and Ruthvik, they give out great local cuts in the Ardrey Kell area!!",
        image: "https://source.unsplash.com/random/600x400/?hackathon,coding",
        attendees: "N/A",
        organizer: "QCB",
        registerLink: "https://qcb-website.vercel.app/?fbclid=PAZXh0bgNhZW0CMTEAAacTEXkOae2kq4_woSWs2sfYuaqWhfEiQ6l7PyrpRtBuqORwYxi1z5xBZntR-A_aem_fVAQBatX2AJHD_ZGmICn2g"
      },
      
      
      

    ];
    
    setTimeout(() => {
      setEvents(mockEvents);
      setLoading(false);
    }, 800); // Simulate loading delay
  }, []);

  const toggleEventExpand = (eventId) => {
    setExpandedEvent(expandedEvent === eventId ? null : eventId);
  };

  const toggleSaveEvent = (eventId) => {
    if (savedEvents.includes(eventId)) {
      setSavedEvents(savedEvents.filter(id => id !== eventId));
    } else {
      setSavedEvents([...savedEvents, eventId]);
    }
  };

  const filteredEvents = events.filter(event => {
    if (filters.category !== 'all' && event.category !== filters.category) return false;
    
    const now = new Date();
    const eventDate = new Date(event.date);
    if (filters.date === 'upcoming' && eventDate < now) return false;
    if (filters.date === 'past' && eventDate >= now) return false;
    
    if (filters.search && 
        !event.title.toLowerCase().includes(filters.search.toLowerCase()) &&
        !event.description.toLowerCase().includes(filters.search.toLowerCase())) {
      return false;
    }
    
    return true;
  });

  return (
    <div className="events-container">
      <header className="events-header">
        <h1>Upcoming Events</h1>
        <p>Discover and join exciting local activities</p>
      </header>

      <div className="events-controls">
        <div className="search-bar">
          <FiSearch className="search-icon" />
          <input
            type="text"
            placeholder="Search events..."
            value={filters.search}
            onChange={(e) => setFilters({...filters, search: e.target.value})}
          />
        </div>

        <div className="filter-group">
          <div className="filter-select">
            <FiFilter className="filter-icon" />
            <select
              value={filters.category}
              onChange={(e) => setFilters({...filters, category: e.target.value})}
            >
              <option value="all">All Categories</option>
              <option value="academic">Academic</option>
              <option value="social">Social</option>
              <option value="sports">Sports</option>
              <option value="career">Career</option>
            </select>
          </div>

          <div className="filter-select">
            <FiCalendar className="filter-icon" />
            <select
              value={filters.date}
              onChange={(e) => setFilters({...filters, date: e.target.value})}
            >
              <option value="upcoming">Upcoming</option>
              <option value="past">Past Events</option>
            </select>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="loading-indicator">
          <div className="spinner"></div>
          <p>Loading events...</p>
        </div>
      ) : filteredEvents.length === 0 ? (
        <div className="no-results">
          <p>No events found matching your criteria.</p>
          <button 
            className="reset-btn"
            onClick={() => setFilters({ category: 'all', date: 'upcoming', search: '' })}
          >
            Reset Filters
          </button>
        </div>
      ) : (
        <div className="events-grid">
          {filteredEvents.map(event => (
            <div 
              key={event.id} 
              className={`event-card ${expandedEvent === event.id ? 'expanded' : ''}`}
            >
              <div 
                className="event-image"
                style={{ backgroundImage: `url(${event.image})` }}
              >
                <button 
                  className={`save-btn ${savedEvents.includes(event.id) ? 'saved' : ''}`}
                  onClick={() => toggleSaveEvent(event.id)}
                >
                  <FiBookmark />
                </button>
              </div>
              
              <div className="event-content">
                <div className="event-header" onClick={() => toggleEventExpand(event.id)}>
                  <div>
                    <span className="event-category">{event.category}</span>
                    <h3>{event.title}</h3>
                  </div>
                  {expandedEvent === event.id ? <FiChevronUp /> : <FiChevronDown />}
                </div>
                
                <div className="event-meta">
                  <span><FiCalendar /> {new Date(event.date).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })}</span>
                  <span><FiClock /> {event.time}</span>
                  <span><FiMapPin /> {event.location}</span>
                </div>

                <div className="event-footer">
                  <span className="attendees">
                    <FiUser /> {event.attendees} attending
                  </span>
                  <span className="organizer">
                    Hosted by {event.organizer}
                  </span>
                </div>

                {expandedEvent === event.id && (
                  <div className="event-details">
                    <p>{event.description}</p>
                    <div className="event-actions">
                      <a href={event.registerLink} target="_blank" rel="noopener noreferrer">
                        <button className="register-btn">Register Now</button>
                      </a>
                      <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
                        <button className="secondary-btn">
                          <FiShare2 /> Share
                        </button>
                      </a>
                      <a href="https://docs.google.com/document/d/1CZmk7-4qveovkIMw8tcNuOi22RdZncAgLSw0624v3as/edit?usp=sharing" target="_blank" rel="noopener noreferrer">
                        <button className="secondary-btn">
                          <FiHeart /> Interested
                        </button>
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default EventsPage;
